import { render, staticRenderFns } from "./SolusiIT.vue?vue&type=template&id=aeda5d0c&scoped=true"
import script from "./SolusiIT.vue?vue&type=script&lang=js"
export * from "./SolusiIT.vue?vue&type=script&lang=js"
import style0 from "./SolusiIT.vue?vue&type=style&index=0&id=aeda5d0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeda5d0c",
  null
  
)

export default component.exports